// extracted by mini-css-extract-plugin
export default {"title":"KhLld","header":"hKh84","recommendedOutfitsMightLike":"ERoHw"};